import React from 'react';
import { ThemeToggle } from './ThemeToggle';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { copy } from '../copy';
interface HeaderProps {
  title?: string;
  subtitle?: string;
  showProjectLink?: boolean;
  showBackArrow?: boolean;
  backTo?: string;
  minimal?: boolean;
}
export function Header({
  title = copy.brand.name,
  subtitle,
  showProjectLink = true,
  showBackArrow = false,
  backTo = '/case',
  minimal = false
}: HeaderProps) {
  const navigate = useNavigate();
  return <header className="sticky top-0 z-10 flex h-16 items-center justify-between border-b border-slate-200 dark:border-[#333] bg-white/90 dark:bg-[#1a1a1a]/90 px-6 backdrop-blur-xl shadow-sm dark:shadow-none" data-id="element-226">
      <div className="flex items-center gap-4" data-id="element-227">
        {showBackArrow && <button onClick={() => navigate(backTo)} className="p-2 rounded-xl hover:bg-slate-100 dark:hover:bg-white/5 text-slate-500 dark:text-[#a3a3a3] transition-all active:scale-95" data-id="element-228">
            <ArrowLeft size={20} data-id="element-229" />
          </button>}
        {minimal ? <div className="flex items-center gap-2.5" data-id="element-230">
            {title === copy.brand.name && <img src="https://cdn.magicpatterns.com/uploads/wBrpemDYzZmjFSuxiYRjhJ/Imperian.png" alt="Imperian Logo" className="h-6 w-auto" data-id="element-231" />}
            <span className="font-semibold text-base text-slate-900 dark:text-white" data-id="element-232">
              {title}
            </span>
          </div> : <div className="flex items-center gap-2.5 cursor-pointer group" onClick={() => navigate('/cases')} data-id="element-233">
            <img src="https://cdn.magicpatterns.com/uploads/wBrpemDYzZmjFSuxiYRjhJ/Imperian.png" alt="Imperian Logo" className="h-6 w-auto transition-transform group-hover:scale-105" data-id="element-234" />
            <span className="font-semibold text-base text-slate-900 dark:text-white group-hover:text-slate-700 dark:group-hover:text-slate-200 transition-colors" data-id="element-235">
              {title}
            </span>
          </div>}
      </div>
      <div className="flex items-center gap-2" data-id="element-236">
        {!minimal && <>
            <button onClick={() => navigate('/cases')} className="rounded-xl px-3 py-2 text-sm font-medium text-slate-600 dark:text-[#a3a3a3] hover:bg-slate-100 dark:hover:bg-white/5 hover:text-slate-900 dark:hover:text-white transition-all active:scale-95" data-id="element-237">
              {copy.header.casesLink}
            </button>
            {showProjectLink && <button onClick={() => navigate('/case')} className="rounded-xl px-3 py-2 text-sm font-medium text-slate-600 dark:text-[#a3a3a3] hover:bg-slate-100 dark:hover:bg-white/5 hover:text-slate-900 dark:hover:text-white transition-all active:scale-95" data-id="element-238">
                {copy.header.caseDetailLink}
              </button>}
            <div className="w-px h-5 bg-slate-200 dark:bg-[#333] mx-1" data-id="element-239" />
          </>}
        <ThemeToggle data-id="element-240" />
      </div>
    </header>;
}